import React from 'react';

const ServiceCard = ({ 
  title, 
  description, 
  image, 
  isReversed = false, 
  hasGradient = false,
  rounded = false
}) => {
  const gradientClass = hasGradient 
    ? 'bg-gradient-to-r from-purple-900 via-purple-600 to-orange-500' 
    : 'bg-white';

  const textColorClass = hasGradient ? 'text-white' : 'text-gray-900';
  const descriptionColorClass = hasGradient ? 'text-gray-200' : 'text-gray-600';
  const roundedImage = rounded ? 'rounded-lg shadow-lg' : '';

  return (
    <div className={`py-20 ${gradientClass}`}>
      <div className="px-6 mx-auto max-w-7xl lg:px-8">
        <div className={`grid items-stretch grid-cols-1 gap-x-12 lg:grid-cols-2 ${isReversed ? 'lg:grid-flow-col-dense' : ''}`}>
          {/* Image */}
          <div className={`flex items-stretch ${isReversed ? 'lg:col-start-1' : ''}`}>
            <div className="relative w-full h-full min-h-[400px] lg:min-h-[600px]">
              <img
                src={image}
                alt={title}
                className={`absolute inset-0 w-full h-full object-cover ${roundedImage}`}
              />
            </div>
          </div>

          {/* Text Content */}
          <div className={`flex flex-col justify-center mt-8 lg:mt-0 ${isReversed ? 'lg:col-start-2' : ''}`}>
            <div className="max-w-xl px-4 mx-auto lg:px-0 space-y-6">
              <h2 className={`text-3xl font-bold tracking-tight ${textColorClass} sm:text-4xl`}>
                {title}
              </h2>
              <div className={`text-lg leading-relaxed space-y-6 ${descriptionColorClass}`}>
                {description.split('\n\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard; 